export default __webpack_public_path__ + "static/media/doc2.bd39d58d.jpg";